<template>
    <div>
        <CCol sm="12" style="background-size: cover;height:100vh" 
        :style="{
                    backgroundImage: `url(${require('@/assets/img/new/bg-gradient.png')})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    minHeight: '100vh'
                }">
            <div class="text-center">
                <br /><br />
                <h3 class="custom-20px-700">Scan Qr Code</h3>
                <p class="custom-12px-400">Scan the Qr code to start a review</p>
    
                <!-- <p v-if="qrResult">Scanned QR Code Data: <a :href="qrResult" target="_blank">{{ qrResult }}</a> </p> -->
                <p v-if="qrResult">
                    Scanned QR Code Result: <a :href="qrResult" target="_blank">{{ qrResult }}</a>
                </p>
            </div>
            <div class="phone-wrap" :style="{ backgroundImage: `url(${backgroundPhone})` }">
                <!-- <div v-if="showScanner" id="qr-reader" class="full-height"></div> -->
                <div v-if="showScanner" id="qr-reader" class="qr-box"></div>
            </div>
    
    
    
    
        </CCol>
    
        <div class="footer-bottom bg-white">
            <CRow class="justify-content-center mb-2">
                <CCol style="display: flex; align-items: center; justify-content: center">
                    <CCol sm="12" lg="12">
                        <CCol sm="12" lg="12" style="
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  left: 0;
                  right: 0;
                  position: fixed;
                  bottom: 0px;
                  background-color: #fff;
                  padding-bottom: 3px;
                  padding-top: 5px;
                ">
                            <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
                                <CCol @click="GoHome()">
                                    <div class="text-center">
                                        <img src="../assets/img/navigation/navigation/home.png" class="btn-active" style="width: 24px" />
                                        <br />
                                        <label class="text-non-active" style="color:#D0D5DD"> Home</label>
                                    </div>
                                </CCol>
                            </CCol>
    
                            <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
                                <CCol @click="GoToSearch()">
                                    <div class="text-center">
                                        <img src="../assets/img/navigation/navigation/search-normal.png" style="width: 24px" />
                                        <br />
                                        <label class="text-non-active" style="color:#D0D5DD"> Search</label>
                                    </div>
                                </CCol>
                            </CCol>
    
                            <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1; position: relative;">
                                <CCol @click="startScanner">
                                    <img src="../assets/img/scan.png" style="
                        width: 50px;
            position: absolute;
            bottom: 5px;
            left: 50%;
            transform: translateX(-50%);
            border: 5px solid white;
            border-radius: 50%;
                      " />
                                </CCol>
                            </CCol>
    
                            <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
                                <CCol @click="GoInbox()">
                                    <div class="text-center">
                                        <img src="../assets/img/navigation/navigation/notification.png" style="width: 24px" />
                                        <br />
                                        <label class="text-non-active" style="color:#D0D5DD"> Inbox</label>
                                    </div>
                                </CCol>
                            </CCol>
    
                            <CCol sm="2" lg="2" class="p-0 m-0" style="flex: 1">
                                <CCol @click="GoProfile()">
                                    <div class="text-center">
                                        <img src="../assets/img/navigation/navigation/user.png" style="width: 24px" />
                                        <br />
                                        <label class="text-non-active" style="color:#D0D5DD"> Profile</label>
                                    </div>
                                </CCol>
                            </CCol>
                        </CCol>
                    </CCol>
                </CCol>
            </CRow>
    
        </div>
    
    
        <!-- <div v-if="popupqr" class="popup-overlay">
            <div class="popup-content p-2">
                <div class="custom-border-white bg-grey" @click="GoToCollectPoint(qrResult)">
                    <div class="popup-item p-3">
                        <img src="../assets/img/new/coin2.png" class="popup-icon"/>
                        <span>Collect Point</span>
                        <img src="../assets/img/new/arrow-right.png" width="15px" class="arrow-icon">
                    </div>
                </div>
    
                <div class="custom-border-white mt-2" @click="GoToLink(qrResult)">
                    <div class="popup-item p-3">
                        <img src="../assets/img/new/ticket.png" class="popup-icon" />
                        <span>E-Voucher</span>
                        <img src="../assets/img/new/arrow-right.png" width="15px" class="arrow-icon">
                    </div>
                </div>
            </div>
        </div> -->

        <div v-if="isPopupInfo" class="popup-all backdrop-all" style=" margin-top: -50px;">
                <div class="popup-all1">
                    <div class="text-center">
                        <img src="../assets/img/iconfeedback.png" width="60px"/>
                        <br />
                        <h3 class="custom-18px-500 mt-2">
                            We value your opinion!
                        </h3>
                        <p class="text-muted">Help us improve your experience.<br />
Would you like to provide quick feedback before continuing?</p>
<CButton class="custom-border-purple-wp text-white w-100" @click="GoToLinkPoint(qrResult)">
                            <span class="ml-2 mr-2">Yes, please</span>
                        </CButton>
                        <CButton class="custom-btn-grey text-black w-100 mt-2" @click="GoToLinkPoint(qrResult)">
                            <span class="ml-2 mr-2">No, Skip for now</span>
                        </CButton>
                    </div>
            </div>
        </div>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";

Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bgPurpleYellow.png";
import backgroundPhone from "../assets/img/bgphone.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";
import backgroundUrlTestimoni from "../assets/img/bgBluesquare.png";

import Mainlayout from "../containers/HeaderQR.vue";
import Footerlayout from "../containers/TheBottomCustom.vue";
import ToggleCard from "../components/Toggle.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { createFFmpeg, fetchFile } from "@ffmpeg/ffmpeg";
import { Html5Qrcode } from "html5-qrcode";

export default {
    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        ToggleCard,

    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundPhone,
            backgroundMap,
            backgroundUrlTestimoni,
            isActive: false,
            backgroundUrNoArrow,
            mediaRecorder: null,
            recordedChunks: [],
            isRecording: false,
            toggleVideo: false,
            uploadProgress: 0,
            questions: {},
            index: 1,

            question: {},

            showQuestion: true,
            showQuestion2: false,
            isNextButtonDisabled: true,

            elapsedTime: 0,
            timerInterval: null,
            isLanguagePopupVisible2: false,
            PopupFeedback: false,
            rating: 0,
            comment: '',
            SuccessPopup: false,
            instructionText: "You will see the question once you click the record button.",
            showInstruction: "",
            checking: {},
            showConfirmationDialog: false,
            cameraAccessDenied: false,
            Error: false,
            user: {},
            userId: "",
            email: "",
            Message: "",
            showStartSurvey: false,
            showMain: true,
            showScanner: false,
            qrResult: null,
            qrScanner: null,
            popupqr: false,
            code: this.$route.query.code,
            isPopupInfo:false



        };
    },
    async created() {
        AOS.init();
    },
    async mounted() {
        await this.getFirstQuestion();
    },
    computed: {
    finalQrResult() {
        return this.$route.query.code && this.$route.query.code.trim() !== "" 
            ? `https://app.surpriz.ing/directinterview?code=${this.$route.query.code}` 
            : this.qrResult;
        }
    },
    watch: {
        '$route.query.code': {
            immediate: true,
            handler(newCode) {
                if (newCode && newCode !== "undefined" && newCode.trim() !== "") {
                    this.qrResult = `https://app.surpriz.ing/directinterview?code=${newCode}`;
                    this.popupqr = true; // Set popup to true if code exists
                }
            }
        }
    },
    methods: {

        toggle() {
            this.isActive = !this.isActive;
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.user = response.data;
                    console.log("userInfo", this.user);
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        async startRecording(index) {
            try {
                await this.GetCheckingUploadVideo(index, this.questions.sessionId);

                if (this.checking === false) {
                    this.showInstruction = false;

                    // Check if camera access was denied before
                    if (this.cameraAccessDenied) {
                        return this.startRecordingAudio(index); // Proceed with audio recording only
                    }

                    // Request video and audio stream
                    const stream = await navigator.mediaDevices.getUserMedia({
                        video: {
                            width: { ideal: 1280 },
                            height: { ideal: 720 },
                            frameRate: { ideal: 30 },
                        },
                        audio: {
                            echoCancellation: true,
                            noiseSuppression: true,
                            sampleRate: 44100,
                        },
                    });

                    // Set up the video element and media recorder
                    this.$refs.videoElement.srcObject = stream;
                    this.$refs.videoElement.muted = true;
                    this.mediaRecorder = new MediaRecorder(stream);

                    this.mediaRecorder.ondataavailable = (event) => {
                        if (event.data.size > 0) {
                            this.recordedChunks.push(event.data);
                        }
                    };

                    this.mediaRecorder.onstop = () => {
                        this.handleRecordingStop(index);
                    };

                    this.mediaRecorder.start();
                    this.isRecording = true;
                    this.isNextButtonDisabled = true;
                    this.elapsedTime = 0;
                    this.timerInterval = setInterval(() => {
                        this.elapsedTime++;
                        if (this.elapsedTime >= 120) {
                            this.stopRecording();
                        }
                    }, 1000);

                    // Display the question when recording starts
                    if (index === 1) {
                        this.showQuestion = true;
                        this.showQuestion2 = false;
                    } else {
                        this.showQuestion2 = true;
                        this.showQuestion = false;
                        this.getListQuestion(index, this.questions.sessionId);
                    }

                } else {
                    alert("Error. You already submitted this question. Please proceed to the next question by clicking the Next button.");
                }

            } catch (error) {
                console.error("Error accessing media devices: ", error);
                alert("Error accessing media devices. No device found.");
            }
        },

        async startRecordingAudio(index) {
            try {
                await this.GetCheckingUploadVideo(index, this.questions.sessionId);

                if (this.checking === false) {
                    this.showInstruction = false;

                    // Request audio-only stream
                    const stream = await navigator.mediaDevices.getUserMedia({
                        audio: {
                            echoCancellation: true,
                            noiseSuppression: true,
                            sampleRate: 44100,
                        },
                    });

                    // Set up the media recorder for audio
                    this.mediaRecorder = new MediaRecorder(stream);

                    this.mediaRecorder.ondataavailable = (event) => {
                        if (event.data.size > 0) {
                            this.recordedChunks.push(event.data);
                        }
                    };

                    this.mediaRecorder.onstop = () => {
                        this.handleRecordingStop(index);
                    };

                    this.mediaRecorder.start();
                    this.isRecording = true;
                    this.isNextButtonDisabled = true;
                    this.elapsedTime = 0;
                    this.timerInterval = setInterval(() => {
                        this.elapsedTime++;
                        if (this.elapsedTime >= 120) {
                            this.stopRecording();
                        }
                    }, 1000);

                    // Display the question when recording starts
                    if (index === 1) {
                        this.showQuestion = true;
                        this.showQuestion2 = false;
                    } else {
                        this.showQuestion2 = true;
                        this.showQuestion = false;
                        this.getListQuestion(index, this.questions.sessionId);
                    }

                } else {
                    alert("Error. You already submitted this question. Please proceed to the next question by clicking the Next button.");
                }

            } catch (error) {
                console.error("Error accessing media devices: ", error);
                alert("Error accessing media devices. No device found.");
            }
        },

        allowCamera() {
            this.showConfirmationDialog = false;
            this.allowCameraAccess = true;
            this.cameraAccessDenied = false; // Reset the camera access denial status

            // Proceed with the existing logic to start recording
            this.startRecording(1);
        },

        denyCamera() {
            this.showConfirmationDialog = false;
            this.allowCameraAccess = false;
            this.cameraAccessDenied = true; // Mark camera access as denied
            //alert("Camera access denied.");
            this.startRecordingAudio(1);
        },

        stopRecording() {
            if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
                this.mediaRecorder.stop();
                if (this.$refs.videoElement.srcObject) {
                    const tracks = this.$refs.videoElement.srcObject.getTracks();
                    tracks.forEach((track) => track.stop());
                }
                this.$refs.videoElement.srcObject = null;
                this.recordedChunks = [];
                this.uploadProgress = 0;
                this.isRecording = false;
                clearInterval(this.timerInterval); // Stop the timer
                this.timerInterval = null;
                clearTimeout(this.stopRecordingTimeout);
            }
        },

        handleRecordingStop(index) {
            const recordedBlob = new Blob(this.recordedChunks, {
                type: this.allowCameraAccess ? "video/webm" : "audio/webm",
            });

            this.recordedChunks = [];

            const formData = new FormData();
            formData.append("file", recordedBlob, this.allowCameraAccess ? "rekaman.webm" : "rekaman_audio.webm");
            formData.append("sessionId", this.questions.sessionId);
            formData.append("indexNo", index);
            formData.append("userId", this.userId);

            this.$API.post(this.$uploadFile, formData, {
                onUploadProgress: (progressEvent) => {
                    this.uploadProgress = Math.round(
                        (progressEvent.loaded / progressEvent.total) * 100
                    );
                },
            }).then((response) => {
                if (response.status === 200) {
                    this.videoId = response.data.videoId;
                    this.InsertVideoText(this.videoId);
                    console.log("Successfully uploaded.");
                } else {
                    console.error("Failed to upload.");
                }
            }).catch((error) => {
                console.error("Error:", error);
            });

            this.isNextButtonDisabled = false;
        },
        async GetCheckingUploadVideo(index, sessionId) {
            try {
                const response = await this.$API.get(this.$CheckVideoSessionIndex + "?sessionId=" + sessionId + "&indexNo=" + index);
                if (response.status === 200) {
                    this.checking = response.data;
                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        InsertVideoText(videoId) {

            this.$API
                .get(this.$ExtractAudioText + "/" + videoId)
                .then((response) => {

                    if (response.status == 200) {
                        console.log("success convert");
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },


        toggleRecording(index) {
            if (this.isRecording) {
                this.stopRecording();
            } else {
                if (index === 1) {
                    // For the first question, show confirmation dialog
                    this.showConfirmationDialog = true;
                } else {
                    // For subsequent questions, check if camera access is allowed
                    if (this.allowCameraAccess) {
                        this.startRecording(index);
                    } else {
                        this.startRecordingAudio(index);
                    }
                }
            }
        },
        async GoToNextQuestion(index, sessionId) {
            this.isNextButtonDisabled = true;
            this.showInstruction = true;
            this.showQuestion2 = false;
            this.showQuestion = false;
            this.index++;
            //this.getListQuestion(index, sessionId);

        },
        async getFirstQuestion() {
            try {
                const response = await this.$API.get(this.$GetFirstQuestionByQrCode + "?code=" + this.$route.query.code);

                if (response.status === 200) {
                    this.questions = response.data;
                    this.userId = response.data.userId;
                    this.email = response.data.email;
                    await this.tryLogin(); // Use await to handle any errors in tryLogin
                } else {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = response.data || 'An error occurred';
                }
            } catch (error) {
                this.Loading = false;
                this.Error = true;
                this.Message = error.response ?.data || 'An error occurred';
            }
        },

        async tryLogin() {
            try {
                const formData = new FormData();
                formData.append("Email", "defaultuser@gmail.com");
                formData.append("Password", "Cellnet777#");

                const response = await this.$API.post(this.$LoginToken, formData, { withCredentials: true });

                if (response.status === 200) {
                    this.GetInfoUser();
                } else {
                    // Handle non-200 status here if needed
                }
            } catch (error) {
                this.Loading = false;
                this.Error = true;
                this.Message = error.response ?.data ?.message || 'An error occurred during login';
            }
        },

        async getListQuestion(index, sessionId) {
            this.showQuestion = false;
            if (index > 6) {
                this.stopRecording();
                this.SuccessPopup = true;
            } else {
                try {
                    const codeCompany = this.$route.query.code;

                    if (codeCompany != null) {
                        const response = await this.$API.get(
                            `${this.$GetNextQuestionByCode}?sessionId=${sessionId}&indexNo=${index}&code=${codeCompany}`, {
                                withCredentials: true,
                            }
                        );
                        if (response.status === 200) {
                            if (response.data === 'Skip') {
                                const response = await this.$API.get(
                                    `${this.$GetNextQuestionByCode}?sessionId=${sessionId}&indexNo=${index+1}&code=${codeCompany}`, {
                                        withCredentials: true,
                                    });
                                this.question = response.data;
                                this.showQuestion = false;

                            } else {
                                this.question = response.data;
                                this.showQuestion = false;

                            }



                        } else {}

                    } else {
                        const response = await this.$API.get(
                            `${this.$GetNextQuestion}/${sessionId}/${index}`, {
                                withCredentials: true,
                            }
                        );
                        if (response.status === 200) {
                            this.question = response.data;
                            this.showQuestion = false;
                        } else {}

                    }
                } catch (error) {}
            }
        },
        SubmitData() {

            const field = this.$route.query.field;
            const expertise = this.$route.query.expertise;

            const formData = new FormData();

            formData.append("email", this.email);
            formData.append("experties", expertise);
            formData.append("field", field);

            this.$API
                .post(this.$RegisterInterest, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {
                                this.isLanguagePopupVisible2 = true;
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        OpenHomepage() {
            this.SignOut();
            this.SuccessPopup = true;

        },
        SignOut: function() {
            return this.$API
                .get(this.$SignOut, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        //this.$router.push("/Login");
                    }
                });
        },
        formatTime(seconds) {
            const minutes = Math.floor(seconds / 60);
            const secs = seconds % 60;
            return `${minutes.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        },
        closePopup2() {
            this.isLanguagePopupVisible2 = false;
        },
        OpenFeedback() {
            this.isLanguagePopupVisible2 = false;
            this.PopupFeedback = true;
        },
        updateStars(index) {
            this.rating = index;
        },
        getStarSrc(index) {
            return index <= this.rating ? require('../assets/img/star-yellow.png') : require('../assets/img/star-grey.png');
        },
        SubmitFeedback() {
            this.PopupFeedback = false;
            const formData = new FormData();
            formData.append("comment", this.comment);
            formData.append("rate", this.rating);

            this.$API
                .post(this.$SubmitFeedbacks, formData)
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            if (response.data.status !== 400) {

                                this.SuccessPopup = true;
                            } else {
                                this.Loading = false;
                                this.Message = response.data.message;
                                this.Error = true;
                            }
                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        closeSuccessFeedback() {
            this.SuccessPopup = false;
            this.$router.push("/");
        },
        GoToLogin() {
            let path = this.$router.currentRoute.path;
            if (path.toLowerCase() != "/Login") {

                this.$router.push({
                    path: '/Login',
                    query: {
                        targetUrl: this.$router.currentRoute.fullPath,
                    }
                })

            }
        },
        ShowQuestionSurvey() {
            this.showMain = false;
            this.showStartSurvey = true;
        },
        startScanner() {
            this.showScanner = true;
            this.$nextTick(() => {
                if (document.getElementById('qr-reader')) {
                    this.qrScanner = new Html5Qrcode("qr-reader");
                    this.qrScanner.start(
                    { facingMode: "environment" },
                    {
                        fps: 10,
                        qrbox: { width: 280, height: 280 }, // <-- match .qr-box
                    },
                    (decodedText) => {
                        this.qrResult = decodedText;
                        this.popupqr = true;
                        this.qrScanner.stop();
                        this.showScanner = false;

                         // ✅ Auto redirect after successful scan
  if (decodedText) {
    // Check if it's a full URL or just a code
    if (decodedText.startsWith("http")) {
      window.location.href = decodedText;
    } else {
      // If the QR contains only the code, go to your direct interview page
      window.location.href = `https://app.surpriz.ing/directinterview?code=${decodedText}`;
    }
  }
                    }
                    ).catch(err => console.error("QR start error:", err));
                }
            });
        },

        stopScanner() {
            if (this.qrScanner) {
                this.qrScanner.stop();
            }
            this.showScanner = false;
        },
        GoQR() {
            this.classclick = true;
            this.classclickgrey = false;
            this.$router.push("HomeSurvey");

        },
        GoHome() {
            this.$router.push("Home");

        },
        // GoToLink(url) {
        //     if (!url) {
        //     console.error("No QR result found!");
        //     return;
        //     }
        //     // Check if it's an external link (starts with http or https)

        //     window.open(url); // Navigate within Vue Router

        // },
        GoToLink(qrResult) {
            const code = this.$route.query.code;
            const finalLink = code ?
                `directinterview?code=${code}&point=no` :
                qrResult;

            window.location.href = finalLink; // Redirect to the correct URL
        },
        GoToLinkPoint(qrResult) {
            const code = this.$route.query.code;
            const finalLink = code ?
                `directinterview?code=${code}&point=yes` :
                qrResult;

            window.location.href = finalLink; // Redirect to the correct URL
        },
        GoToCollectPoint() {
            this.popupqr = false;      // hide popup QR
            this.isPopupInfo = true;   // show info popup
        },
        GoToSearch() {
            this.$router.push("/Search");

        },
        GoInbox() {
            this.$router.push("/Notification");

        },
        GoProfile() {
            this.$router.push("/Setting");

        }



    },
};
</script>

<style scoped>
@import url("https://fonts.cdnfonts.com/css/general-sans");
body {
    top: 0 !important;
    font-family: "General Sans", sans-serif;
}

.video-container {
    position: relative;
    width: 100%;
    background-color: black;
    border-radius: 21px;
    max-width: 100%;
}

.button-container {
    position: absolute;
    top: 90%;
    left: 50%;
    transform: translate(-50%, -50%);
}

.record-button {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #f44336;
    color: white;
    font-size: 24px;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.record-button:hover {
    background-color: #d32f2f;
}

.record-button.recording {
    background-color: #8bc34a;
}

.record-button i {
    margin-top: 8px;
}

.hideAfterStop {
    display: none;
}

video {
    border-radius: 21px;
    width: 100%;
}

.disabled {
    pointer-events: none;
    opacity: 0.5;
}

.timer {
    position: absolute;
    top: 24px;
    right: 0px;
    -webkit-transform: translateX(-20%);
    transform: translateX(-20%);
    font-size: 20px;
    color: white;
    background: #F02222;
    padding: 5px 10px;
    border-radius: 17px;
}

@media (max-width: 768px) {
    .popup-all1 {
        width: 90%;
        max-width: 500px;
        padding: 20px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        background-color: #fff;
        border: 1px solid #ccc;
        border-radius: 20px;
        z-index: 1000;
        margin: 0 auto;
        margin-top: 50%;
    }
}

#qr-reader {
    width: 100%;
    max-width: 400px;
    max-height: 500px;
    margin: 0 auto;
}

.full-height {
    height: 100%;
    width: 100%;
}

.popup-item {
    display: flex;
    align-items: center;
    width: 100%;
}

.popup-icon {
    width: 24px;
    height: 24px;
    margin-right: 10px;
}

.arrow-icon {
    margin-left: auto;
    font-size: 16px;
    font-weight: bold;
}



.phone-wrap{
  position: relative;
  height: 500px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;                /* center fallback if absolute fails */
  align-items: center;
  justify-content: center;
}

.qr-box{
  position:absolute;
  top:36%;
  left:50%;
  transform: translate(-50%, -62%); /* was -50% */
  width:280px;
  /* height:280px; */
  border-radius:24px;
  overflow:hidden;
  box-shadow:0 10px 30px rgba(0,0,0,.15);
}

/* make the camera fill the square nicely */
.qr-box video, 
.qr-box canvas {
  width: 100% !important;
  height: 100% !important;
  object-fit: cover;
  border-radius: 24px;
}

/* hide the library’s header/footer chrome if you want a clean look */
#qr-reader__dashboard, 
#qr-reader__status_span, 
#qr-reader__dashboard_section_csr, 
#qr-reader__camera_selection, 
#qr-reader__dashboard_section_swaplink,
#qr-reader__footer {
  display: none !important;
}

</style>
